export default "__VITE_ASSET__Chaakh4J__"